import { create_div, min_max } from 'js/utils';
import './request_pricing.scss';

init();
function init(){
    document.addEventListener('gform/post_render', (e)=>{
        const { formId } = e.detail;
        if( formId !== 12 ) return;
        init_fields_hover_effect(formId)
    });
}

function init_fields_hover_effect(form_id){
    const form = document.querySelector('#gform_'+form_id)
    if( !form ) return;
    form.querySelectorAll('.ginput_container').forEach(init_input_hover_effect)
}

function init_input_hover_effect(input_con){

    if( input_con.classList.contains('ginput_recaptcha') ) return;
    if( input_con.classList.contains('ginput_container_textarea') ) return;

    input_con.classList.add('input_highlight');

    const el = create_div('highlight', input_con);

    const padding = 2;
    const width  = 70;

    let x1;
    let x_max;

    const highlight_move = (e)=>{
        let x = -(x1 - e.x);
        x = min_max(x, -padding, x_max);
        el.style.transform = `translateX(${x}px)`;
    }

    input_con.addEventListener('pointerenter', ()=>{
        // const offset = get_offset(input_con);
        // x1 = offset.left + (width/2);
        x1 = input_con.getBoundingClientRect().x + (width/2);
        x_max = input_con.offsetWidth - (width - padding);
        el.classList.add('active')
        input_con.addEventListener('pointermove', highlight_move)
    })

    input_con.addEventListener('pointerleave', ()=>{
        el.classList.remove('active')
        input_con.removeEventListener('pointermove', highlight_move)
    })
}
